import { useEffect, useState } from "react";
import BillItem from "../bills/bill_item";
import { Table, Tabs, Tab } from "react-bootstrap";
import { useSelector } from "react-redux";
import axios from "axios";
import { baseURL } from "../../store/conf";

export default function BillsWrapper({ setMessage }) {
  const AuthUser = useSelector((state) => state.AuthUser.user);
  const [currentPage, setCurrentPage] = useState(1);
  const [bills, setBills] = useState({});

  // load bills
  const loadBills = () => {
    let header = { Authorization: `Bearer ${AuthUser.token.access}` };
    axios
      .get(`${window.location.protocol}//${baseURL}/bill/bills/?page=${currentPage}`, {
        headers: header,
      })
      .then((response) => {
        setBills(response.data);
      })
      .catch((error) => {
        setMessage({ type: "alert alert-danger", msg: "error getting bills." });
        console.log(error);
      });
  };

  useEffect(() => {
    loadBills();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  // Handle vote updates
  const handleVoteUpdate = () => {
    loadBills(); // Reload bills to get updated vote counts
  };

  return (
    <>
      <Tabs
      id="voter-bill-tabs"
      defaultActiveKey="my-bills"
      className="mt-4 mb-3"
      transition={false}
    >
      <Tab eventKey="my-bills" title="My Bills">
        <p>Your Bill Focus lists will appear here once connected.</p>
      </Tab>
      <Tab eventKey="all-bills" title="All Bills">
      <Table striped bordered hover responsive="lg">
        <thead>
          <tr className="fw-normal ">
            <th className="fw-semibold fs-5 text-nowrap">Bill Number</th>
            <th className="fw-semibold fs-5 text-nowrap" style={{ minWidth: "250px" }}>
              Short Title
            </th>
            <th className="fw-semibold fs-5 text-nowrap">Scheduled For Vote</th>
            <th className="fw-semibold fs-5 text-nowrap">Advisement</th>
            <th className="fw-semibold fs-5 text-nowrap">My Vote</th>
            <th className="fw-semibold fs-5 text-nowrap">District Tally</th>
            <th className="fw-semibold fs-5 text-nowrap">National Tally</th>
            <th className="fw-semibold fs-5 text-nowrap">Advisement & More</th>
          </tr>
        </thead>
        <tbody>
          {bills?.results?.map((bill, index) => (
            <BillItem bill={bill} key={index} index={index} onVoteUpdate={handleVoteUpdate} />
          ))}
        </tbody>
        <tfoot className="border-0">
          <tr className="p-2 border-0">
            <td colSpan={4} className="border-0"></td>
            <td colSpan={4} className="border-0" style={{ textAlign: "right" }}>
              {bills?.previous ? (
                <span
                  className="btn btn-outline-success mx-1 p-0 px-3"
                  onClick={() => setCurrentPage(currentPage - 1)}>
                  Previous
                </span>
              ) : (
                ""
              )}

              {bills?.previous ? (
                <span
                  className="btn btn-outline-success mx-1 p-0 px-3"
                  onClick={() => setCurrentPage(currentPage - 1)}>
                  {currentPage - 1}
                </span>
              ) : (
                ""
              )}

              <span className="btn btn-success mx-1 p-0 px-3">{currentPage}</span>

              {bills?.next ? (
                <span
                  className="btn btn-outline-success mx-1 p-0 px-3"
                  onClick={() => setCurrentPage(currentPage + 1)}>
                  {currentPage + 1}
                </span>
              ) : (
                ""
              )}

              {bills?.next ? (
                <span
                  className="btn btn-outline-success mx-1 p-0 px-3"
                  onClick={() => setCurrentPage(currentPage + 1)}>
                  Next
                </span>
              ) : (
                ""
              )}
            </td>
          </tr>
        </tfoot>
      </Table>
        </Tab>
      </Tabs>
    </>
  );
}
